import 'leaflet';

export default class MapListener {
    constructor() {
        const {__} = wp.i18n;

        document.addEventListener("DOMContentLoaded", () => {
            let mapContainer = document.querySelector('.leaflet-map');

            if (mapContainer) {

                let zoom = 16;
                if (L.Browser.mobile === true) {
                    zoom = 14;
                }

                let latitude = mapContainer.getAttribute('data-map-latitude');
                let longitude = mapContainer.getAttribute('data-map-longitude');
                let googleMapsUrl = mapContainer.getAttribute('data-map-google-maps-url');

                let map = L.map(mapContainer.getAttribute('id'), {
                    dragging: !L.Browser.mobile,
                    tap: !L.Browser.mobile
                }).setView([latitude, longitude], zoom);

                L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                }).addTo(map);
                // map.addControl(new L.Control.Fullscreen({
                //     title: {
                //         'false': __('View Fullscreen', 'rwn'),
                //         'true': __('Exit Fullscreen', 'rwn')
                //     }
                // }));
                // let greenMarker = L.AwesomeMarkers.icon({
                //     icon: 'film',
                //     prefix: 'fa',
                //     iconColor: '#fff',
                //     markerColor: 'green',
                //     spin: false,
                //     extraClasses: ''
                // });

                // L.marker([latitude, longitude], {
                //     // icon: greenMarker
                // }).addTo(map);

                // map.pm.setGlobalOptions({
                //     markerStyle: {
                //         icon: blueMarker
                //     }
                // });
                // map.pm.setLang('pl');

                let googleBtn = L.Control.extend({
                    options: {
                        position: 'bottomright'
                    },
                    onAdd: function (map) {
                        let container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                        let button = L.DomUtil.create('a', 'leaflet-control-button w-auto px-3', container);
                        button.text = __('Open in Google Maps', 'rwn');
                        button.href = googleMapsUrl;
                        button.target = '_blank';

                        return container;
                    }
                });
                map.addControl(new googleBtn());
            }
        });
    }
}